import { Flex, Text, ActionIcon, Tooltip } from "@mantine/core";
import React from "react";
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/prop-types */
import { ICellTextProps } from "ka-table/props";
import { PencilSquareIcon } from "@heroicons/react/20/solid";
import { useNavigate } from "react-router-dom";
import { useAuthInfo } from "@propelauth/react";
import useWorkspaceStore from "../../store/workspace/workspaceStore";

/**
 * Custom cell component.
 */
const SignalNameCell: React.FC<ICellTextProps> = React.memo(
  ({
    column, dispatch, rowKeyValue, ...props
  }) => {
    const value = props.rowData[`${column.key}`];
    const navigate = useNavigate();
    const { workspace } = useWorkspaceStore();
    const { accessHelper } = useAuthInfo();
    return (
      <Flex
        gap={10}
        align="center"
        justify="space-between"
        className="group z-10 relative duration-100 ease-linear hover:bg-gray-200 p-1 rounded-md"
      >
        <Text c="text.9" size="sm" fw={600}>{value}</Text>
        {/* {accessHelper?.hasPermission(workspace?.id, "can_update_automation") && ( */}
        <Tooltip label="Edit signal" withArrow position="bottom" transitionProps={{ transition: 'fade', duration: 150 }}>
          <ActionIcon
            size="sm"
            variant="subtle"
            onClick={() => {
              navigate(`/home/${workspace?.unique_identifier}/signals/${props.rowData.id}/edit`);
            }}
            className="opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <PencilSquareIcon className="h-4 w-4 text-gray-400 hover:text-gray-500" />
          </ActionIcon>
        </Tooltip>
        {/* )} */}
      </Flex>
    );
  },
);
export default SignalNameCell;
